import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './WpExchange.module.less';
import { setShowWpExchange, getWpExchangeResult } from '../../actions/wallpaperPay';
import { logging } from '../../actions/log';
import bgImg from '../../static/wp/wp_exchange_bg.jpg';

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);
  const [btnText, setBtnText] = useState('立即兑换');
  const [textChange, setTextChange] = useState(false);
  const [value, setValue] = useState('');
  const logInfoData = useSelector(selectLogInfo);
  const [show, setShow] = useState(false);
  const [infoImg, setInfoImg] = useState('');
  const [defaultPlaceholder, setDefaultPlaceholder] = useState('请输入兑换码，不区分大小写');

  const showbg = () => {
    return new Promise((re, rj) => {
      const img = new Image();
      img.src = bgImg;
      img.onload = () => {
        re(bgImg);
      };
      img.onerror = () => {
        rj();
      };
    });
  };

  useEffect(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_Convert',
        label: '',
        param2: {
          source: logInfoData?.source,
          source_p: logInfoData?.source_p,
          source_pp: logInfoData?.source_pp,
        },
      }),
    );
    showbg().then(res => {
      setShow(true);
      setInfoImg(res);
    });
  }, []);

  const handleChange = e => {
    setValue(e.target.value);
    if (e.target.value?.length > 15 && e.target.value?.length <= 32) {
      setTextChange(true);
    } else {
      setTextChange(false);
    }
  };

  const submitExchange = () => {
    setTextChange(false);
    setBtnText('兑换中...');
    dispatch(getWpExchangeResult(value));
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Convert_Y',
        label: '',
        param2: {
          source: logInfoData?.source,
          source_p: logInfoData?.source_p,
          source_pp: logInfoData?.source_pp,
        },
      }),
    );
  };

  return (
    <div className={styles.wp_exchange_box}>
      <div
        className="wp_exchange_info"
        style={{
          backgroundImage:
            infoImg !== ''
              ? `url(${infoImg})`
              : ' linear-gradient(316deg, #FFF 0%, #F6E0C4 68.43%, #F9D3A3 79.35%, #FFBF70 100%)',
        }}
      >
        <div className="wp_exchange_title">
          <i
            className="iconfont icon-task_cancel"
            onClick={() => dispatch(setShowWpExchange(false))}
          />
        </div>
        <div className="wp_exchange_operation">
          <div className="wp_operation_title">订阅服务兑换</div>
          <div className="wp_operation_desc">
            将兑换至
            <div className="desc_user_name">{userInfo?.lidNickName}</div>
            <div className="desc_user_num">{`（${
              userInfo?.realname?.indexOf('@') > -1 ? '邮箱：' : '手机：'
            }${userInfo?.uname}）`}</div>
            账号下
          </div>
          <div className="wp_exchange_input_box">
            <input
              type="text"
              className="input"
              placeholder={defaultPlaceholder}
              value={value}
              onChange={handleChange}
              onFocus={() => setDefaultPlaceholder('')}
            />
          </div>
        </div>
        <div className="wp_exchange_line">
          <div className="wp_line_left" />
          <div className="wp_line_title">温馨提示</div>
          <div className="wp_line_right" />
        </div>
        <div className="wp_desc">
          <div className="wp_desc_line">
            1.兑换成功后，订阅服务立即生效，请核对兑换的账号，一经兑换不可更改;
          </div>
          <div className="wp_desc_line">2.请在兑换码有效期内进行兑换，过期将无法兑换；</div>
          <div className="wp_desc_line">3.每个兑换码只能兑换一次，兑换后失效；</div>
          <div className="wp_desc_line">
            4.对于恶意兑换行为，联想应用商店保留对其收回权益的权利。
          </div>
        </div>
        <div
          className={`wp_exchange_btn ${textChange ? 'btn_color_deep' : 'btn_color_light'}`}
          onClick={textChange ? submitExchange : () => {}}
        >
          <div>{btnText}</div>
        </div>
      </div>
    </div>
  );
});
